import React, { useState } from 'react';
import './ContactForm.css'; // Import CSS file for styling

function CompContactUs() {
  const [formData, setFormData] = useState({
    firstname: '',
    lastname: '',
    country: 'australia',
    subject: ''
  });

  const handleChange = (event) => {
    const { name, value } = event.target;
    setFormData(prevState => ({
      ...prevState,
      [name]: value
    }));
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    // You can handle form submission logic here, like sending the data to a server
    alert("We will Contact You shortly!");
  };

  return (
    <div className="policy">
      <h2 className="subtextcolor"> Contact Us</h2>
      <div className='text-info'>
      
      
      We are thrilled to receive your message! Our dedicated team is here to assist you, whether you have questions, need support, or simply want to share your thoughts. Feel free to reach out by filling out the contact form or using the contact information provided.     
      </div>
        
      <div>
      <h3>Contact-US </h3>
      <div className="container-form" >
        <form onSubmit={handleSubmit}>
          <label htmlFor="fname">First Name</label>
          <input required type="text" id="fname" name="firstname" value={formData.firstname} onChange={handleChange} placeholder="Your name.." />

          <label htmlFor="lname">Last Name</label>
          <input required type="text" id="lname" name="lastname" value={formData.lastname} onChange={handleChange} placeholder="Your last name.." />

          

          <label htmlFor="subject">Subject</label>
          <textarea required id="subject" name="subject" value={formData.subject} onChange={handleChange} placeholder="Write something.." style={{ height: '200px' }}></textarea>

          <input type="submit" value="Submit" className="submit-btn" />
        </form>
      </div>
    </div >  
    <div className="contact-d">
    <h4>
        <span className="textcolor">Phone:</span> +1(973) 907-87899
      </h4>
      <h4>
        <span className="textcolor">Email:</span> contact@vivals.com
      </h4>
      <h4>
        <span className="textcolor">Operating Hours:</span> 9am - 5pm{" "}
      </h4>
      <h4>
        Your interest in our products/services is valued, and we are committed
        to providing you with optimal support and assistance.
      </h4>
    </div>
     
    </div>
   
  );
}

export default CompContactUs;
